<template>
<div class="container-full-width default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro"
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    />

    <div class="row">
      <div class="col-12 lbl-deal-title mb-2">
        <span class="lbl-deal-title mb-2 w-100">CONSULTA VENDAS</span>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
      </div>
    </div>
    <hr />

    <div class="row mb-3 p-5">
        <div class="col-6">
            <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
        </div>
        <div class="col-6">
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio1" class="custom-control-input" value="1" v-model="tipoResumo">
                    <label class="custom-control-label data-list" for="customRadio1">Não agrupar</label>
                </div>
            </div>
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio2" class="custom-control-input" value="2" v-model="tipoResumo">
                    <label class="custom-control-label data-list" for="customRadio2">Agrupar por usuário</label>
                </div>
            </div>
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio3" class="custom-control-input" value="3" v-model="tipoResumo">
                    <label class="custom-control-label data-list" for="customRadio3">Agrupar por cliente</label>
                </div>
            </div>
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio4" class="custom-control-input" value="4" v-model="tipoResumo">
                    <label class="custom-control-label data-list" for="customRadio4">Agrupar por grupo de cliente</label>
                </div>
            </div>
            <div class="w-100">
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio5" class="custom-control-input" value="5" v-model="tipoResumo">
                    <label class="custom-control-label data-list" for="customRadio5">Agrupar por estado</label>
                </div>
            </div>
        </div>
    </div>

    <hr>

    <div class="row mb-5" v-if="detalheVendas.length > 0">
        <div class="col-12 lbl-deal-title mb-2">
            RESUMO DAS VENDAS
            <v-button label="Excel" class="float-right" @click="loadResumo(true)"></v-button>
            <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
        </div>
        <div class="col-12">
            <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                <div style="overflow: auto">

                    <table id="relatorio" class="table table-striped table-hover responsive tablesorter w-100">
                        <thead>
                            <tr style="height: 37px">
                                <th class="textual header" style="width:15%" title=""><i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="" title="" v-for="(col, index) in resumoVendas.meses" :key="index" > {{ col }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                                <th class="numerico header" style="" title=""> Total <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="height: 37px" v-for="(row, index) in resumoVendas.vendas" :key="index">
                                <td class="textual">{{ row.label }}</td>
                                <td class="numerico" title="" v-for="(val, index) in row.valores" :key="index" > {{ val | formatValue(2) }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></td>
                                <td class="numerico" title=""> {{ row.total | formatValue(2) }} <i class="icon-sort"></i><i class="icon-sort-down"></i><i class="icon-sort-up"></i></td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>

    <div class="row mb-5">
        <div class="col-12" v-if="chartValues.length > 0">
            <!-- <dash-card :params="{ name: 'GRAPH_VENDAS_PEDIDO', chart: { type: 'AreaChart' } }" :filter="filter"></dash-card>  -->
            <chart :params="paramsChart"></chart>
        </div>
    </div>


    <div class="row mb-5">
        <div class="col-12 lbl-deal-title mb-2">
            PEDIDOS
            <v-button label="Excel" class="float-right" @click="loadResumo(true)"></v-button>
            <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
        </div>
        <div class="col-12" v-if="detalheVendas.length == 0">
            Nenhuma venda encontrada
        </div>
        <div v-else class="col-12">
            <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                <div style="overflow: auto">

                    <table id="relatorio" class="table table-striped table-hover responsive tablesorter w-100">
                        <thead>
                            <tr style="height: 37px">
                                <th class="textual header" style="width:5%" title="">Pedido</th>
                                <th class="textual header" style="width:5%" title="">Data</th>
                                <th class="textual header" style="width:10%" title="">Cliente</th>
                                <th class="textual header" style="width:10%" title="">Cidade</th>
                                <th class="textual header" style="width:2%" title="">Estado</th>
                                <th class="numerico header" style="width:6%" title="">Total do Pedido</th>
                                <th class="textual header" style="width:10%" title="">Nome Usuário</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="height: 37px" v-for="(row, index) in detalheVendas" :key="index">
                                <td class="textual">{{ row.npedido }}</td>
                                <td class="textual">{{ row.data | formatData }}</td>
                                <td class="textual">{{ row.nome }}</td>
                                <td class="textual">{{ row.cidade }}</td>
                                <td class="textual">{{ row.uf }}</td>
                                <td class="numerico"> {{ row.total_com_imposto | formatValue(2) }}</td>
                                <td class="textual">{{ row.nome_usuario }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>


</div>

</template>

<script>
import DashCard from '../dashboards/dash-card'
import Chart from './chart'
import Filtro from './filtro'
import { apiORDSpost } from '../shared/api-functions'
import { apiDownload2 } from '../shared/api-functions'

export default {

    components: {
        DashCard, Filtro, Chart
    },

    data () {
        return {
            showfiltro: false,

            resumoVendas: [],
            detalheVendas: [],

            tipoResumo: '1',

            opcoesResumo: { 1: 'resumovendas',
                            2: 'resumousuario',
                            3: 'resumocliente',
                            4: 'resumogrupocliente',
                            5: 'resumoestado' },

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            paramsFiltro: {
                periodo: {
                    label: 'Data da venda',
                    varios: false,
                    data_inicio: null,
                    data_termino: null,
                },

                filtros: [
                    { nome: 'usuario', label: null, url: null, varios: false, values: [] },
                    { nome: 'filial', label: null, url: null, varios: false, values: [] },
                    { nome: 'segmento', label: null, url: null, varios: true, values: [] },
                    { nome: 'grupocliente', label: null, url: null, varios: true, values: [] },
                    { nome: 'estado', label: null, url: null, varios: true, values: [] },
                    { nome: 'grupoestoque', label: null, url: null, varios: true, values: [] },
                ],

            },

            filtro: {
                periodos: [
                    { data_inicio: null, data_termino: null }
                ]
            },



            filter: {            //objeto utilizado pelo filtro de mes
                startDate: null,
                endDate: null,
                codusuario: null,
            },


        }
    },

    watch: {
        tipoResumo: function () {
            this.loadResumo()
            this.loadDetalhes()
        }
    },

    methods: {
        handleCloseFiltro(){
            this.showfiltro = false
        },

        clickRetornar () {
            this.$router.push('/')
        },

        handleShowFiltro () {
            //if (this.paramsFiltro)
            this.showfiltro = true
        },

        filtroChange (filtro) {

            this.showfiltro = false

            this.filtro = filtro

            this.paramsFiltro.filtros[0].values = this.filtro.usuario
            this.paramsFiltro.filtros[1].values = this.filtro.filial
            this.paramsFiltro.filtros[2].values = this.filtro.segmento
            this.paramsFiltro.filtros[3].values = this.filtro.grupocliente
            this.paramsFiltro.filtros[4].values = this.filtro.estado
            this.paramsFiltro.filtros[5].values = this.filtro.grupoestoque

            //this.filtro['opcoes_resumo'].selected

            this.loadResumo()
            this.loadDetalhes()

        },

        async loadResumo (excel) {
            let url = 'consulta/vendas/' + this.opcoesResumo[this.tipoResumo]

            this.filtro.excel = excel

            if (excel)
               apiDownload2(this, url, this.filtro, 'post')
            else {
                const data = await apiORDSpost(this.$store, url, this.filtro, 'post')
                if (data) {
                    this.resumoVendas = data
                } else {
                    this.resumoVendas = []
                }
            }
        },

        async loadDetalhes (excel) {
            this.filtro.excel = excel

            if (excel)
               apiDownload2(this, url, this.filtro, 'post')
            else {
                const data = await apiORDSpost(this.$store, 'consulta/vendas/porpedido', this.filtro, 'post')
                if (data) {
                    this.detalheVendas = data
                } else {
                    this.detalheVendas = []
                }
            }
        },

    },

    computed: {

        // sessao: function () {
        //     return this.$store.getters.getSessao
        // },

        // usuarioList: function () {
        //     //lista de usuarios para selecao
        //     let options = []
        //     for (var x = 0; x < this.$store.getters.getUsuarioList.length; x++) {
        //         options.push({ id: this.$store.getters.getUsuarioList[x].codusuario, text: this.$store.getters.getUsuarioList[x].nome })
        //     }
        //     return options
        // },

        paramsChart: function () {
            if (this.tipoResumo == '1')
                return { chart: { type: 'AreaChart' }, values: this.chartValues }
            else
                return { chart: { type: 'ColumnChart' }, values: this.chartValues }
        },

        chartValues: function () {
            // return [ ['Mês', 'Orçamentos'],
            //         ['Orçamentos', 1000],
            //         ['Confirmados', 1170],
            //         ['Recusados', 660],
            // ]

            if (!this.resumoVendas.vendas || this.resumoVendas.vendas.length == 0)
              return []

            let values = [ ['', 'Valor Vendido'] ]

            console.log(this.resumoVendas)

            if (this.tipoResumo == '1') {
                let meses = this.resumoVendas.vendas[0].valores
                for (var x = 0; x < this.resumoVendas.meses.length; x++) {
                    values.push([ this.resumoVendas.meses[x], meses[x] ])
                }
            } else {
                for (var x = 0; x < this.resumoVendas.vendas.length; x++) {
                    values.push([ this.resumoVendas.vendas[x].label, this.resumoVendas.vendas[x].total ])
                }
            }

            return values
        },

    },

    mounted () {

    },

    created () {
        this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate()) //'2020-02-01'
        this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate()) //'2020-08-17'

        if (this.$route.query.usuario) {
            this.filtro.usuario = [this.$route.query.usuario]
            this.paramsFiltro.filtros[0].values = [ this.filtro.usuario ]
        }

        if (this.$route.query.data_inicio) {
            this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio)
            this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino)
        }

        this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio
        this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino

        this.loadResumo()
        this.loadDetalhes()
    }

}

</script>

<style>

table .numerico {
    min-width:65px;
    text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/consultas/consulta-vendas.vue